import { memo } from "react";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface TransactionDetailRowProps {
    label: string | ReactNode;
    value: ReactNode;
    className?: string;
    slotProps?: {
        label?: {
            className?: string;
        };
        value?: {
            className?: string;
        };
    };
}

export const TransactionDetailRow = memo(function TransactionDetailRow({
    label,
    value,
    slotProps: {
        label: { className: labelClassName = "" } = {},
        value: { className: valueClassName = "" } = {},
    } = {},
    className,
}: TransactionDetailRowProps) {
    return (
        <div className={twMerge("flex justify-between items-center", className)}>
            <span className={twMerge("text-dark leading-[14px] text-[14px]", labelClassName)}>{label}</span>
            <span className={twMerge("text-dark leading-[14px] text-[14px]", valueClassName)}>{value}</span>
        </div>
    );
});

TransactionDetailRow.displayName = "TransactionDetailRow";
